import { MessageCircle } from 'lucide-react';

export function ChatMessageList({ messages, loading }) {
  if (messages.length === 0 && !loading) {
    return (
      <div className="text-center text-muted-foreground text-sm py-8">
        <MessageCircle className="w-8 h-8 mx-auto mb-2 opacity-50" />
        <p>Posez-moi une question sur QCMAntiTriche !</p>
      </div>
    );
  }

  return (
    <>
      {messages.map((m, i) => (
        <div key={`msg-${i}`} className={`flex ${m.role === 'user' ? 'justify-end' : 'justify-start'}`} data-testid={`chat-message-${i}`}>
          <div className={`max-w-[85%] px-3 py-2 rounded-xl text-sm whitespace-pre-wrap ${m.role === 'user' ? 'bg-primary text-primary-foreground' : 'bg-muted text-foreground'}`}>
            {m.content}
          </div>
        </div>
      ))}
      {loading && (
        <div className="flex justify-start">
          <div className="bg-muted px-4 py-2 rounded-xl text-sm">
            <span className="animate-pulse">Réflexion...</span>
          </div>
        </div>
      )}
    </>
  );
}
